import React, { Component, createRef } from 'react'
import cn from 'classnames'
import { injectIntl } from 'react-intl'
import { Chip, Typography, Paper, Collapse, MenuList } from '@material-ui/core'
import { ArrowDropDown } from '@material-ui/icons'
import isEmpty from 'lodash.isempty'
import MenuItem from 'components/override/MaterialUI/MenuItem'
import ArrayHelper from 'helpers/array'
import messages from '../translate'

class AssignAllChipList extends Component {
  constructor(props) {
    super(props)

    this.state = {
      openOptions: !!props.openOptions,
      ...this.initStateData(props),
    }

    this.assignChipRef = createRef()
  }

  componentDidMount() {
    document.addEventListener(
      'click',
      e => this.onClickAssignChipOutside(e),
      false,
    )
  }

  componentWillUnmount() {
    document.removeEventListener(
      'click',
      e => this.onClickAssignChipOutside(e),
      false,
    )
    this.assignChipRef = null
  }

  shouldComponentUpdate(nextProps) {
    const { groups, users } = this.props
    const { groups: nextGroups, users: nextUsers } = nextProps

    if (groups !== nextGroups || users !== nextUsers) {
      this.setState(this.initStateData(nextProps))

      return false
    }

    return true
  }

  onClickAssignChipOutside = event => {
    const { target } = event
    const { onClose, tasksData } = this.props
    const assignChipRef = this.assignChipRef && this.assignChipRef.current

    if (
      !isEmpty(tasksData) &&
      assignChipRef &&
      target &&
      !assignChipRef.contains(target) &&
      !target.closest('.mj-chip-content')
    ) {
      onClose()
    }
  }

  initStateData = props => {
    const {
      groups,
      users,
      groupsValues,
      usersValues,
      intl: { formatMessage },
    } = props
    const indexedGroupsValues = ArrayHelper.map(groupsValues.toArray(), 'id')
    const indexedUsersValues = ArrayHelper.map(usersValues.toArray(), 'id')
    const options = []
    const formatValues = (list, initValues, prefix, title) => {
      if (list.size > 0) {
        options.push({
          title,
          key: `${prefix}`,
          isLabel: true,
        })

        list.forEach((item, index) => {
          const data = {
            index,
            prefix,
            selected: false,
            optionIndex: options.length,
            key: `${prefix}_${item.get('id')}`,
            id: item.get('id'),
            name: item.get('name'),
          }

          options.push(data)

          if (Object.prototype.hasOwnProperty.call(initValues, data.id)) {
            data.selected = true
          }
        })
      }
    }

    formatValues(
      groups,
      indexedGroupsValues,
      'group',
      formatMessage(messages.groups),
    )
    formatValues(
      users,
      indexedUsersValues,
      'user',
      formatMessage(messages.users),
    )

    return { options }
  }

  onOpenOptions = () => {
    const { handleListChange, taskId } = this.props

    handleListChange(taskId)
  }

  onChangeOption = event => {
    const { options } = this.state
    const { task } = this.props
    const value = options[event.currentTarget.value]
    const all = task.assigned_users
      ? [...task.assigned_users, ...task.assigned_user_groups]
      : []
    value.selected = !all.includes(value.id)
    let newUsers = task.assigned_users
    let newGroups = task.assigned_user_groups

    if (value.prefix === 'group') {
      newGroups = value.selected
        ? [...newGroups, value.id]
        : newGroups.filter(g => g !== value.id)
    } else {
      newUsers = value.selected
        ? [...newUsers, value.id]
        : newUsers.filter(g => g !== value.id)
    }

    this.changeFormData(newUsers, newGroups)
  }

  onDeleteChip = chipIndex => {
    const { options } = this.state
    const { task } = this.props
    const value = options[chipIndex]
    const all = task.assigned_users
      ? [...task.assigned_users, ...task.assigned_user_groups]
      : []
    value.selected = !all.includes(value.id)
    let newUsers = task.assigned_users
    let newGroups = task.assigned_user_groups

    if (value.prefix === 'group') {
      newGroups = value.selected
        ? [...newGroups, value.id]
        : newGroups.filter(g => g !== value.id)
    } else {
      newUsers = value.selected
        ? [...newUsers, value.id]
        : newUsers.filter(g => g !== value.id)
    }

    this.changeFormData(newUsers, newGroups)
  }

  changeFormData = (newUsers, newGroups) => {
    const { taskId, onChange } = this.props

    onChange({
      workflow_task: taskId,
      assigned_users: newUsers,
      assigned_user_groups: newGroups,
    })
  }

  render() {
    const { openOptions, options } = this.state
    const {
      label,
      taskId,
      activeListId,
      tasksData,
      intl: { formatMessage },
      task = [],
    } = this.props
    const isActiveTask = activeListId === taskId
    const isOpen = (isActiveTask && tasksData[taskId] === 'open') || openOptions
    const all = task.assigned_users
      ? [...task.assigned_users, ...task.assigned_user_groups]
      : []
    const showHint = !all.length
    const values = options

    return (
      <Paper className="mj-chip-list">
        {!!label && <Typography className="mj-chip-title">{label}</Typography>}
        <div ref={isActiveTask ? this.assignChipRef : null}>
          <Paper className="mj-chip-field" onClick={this.onOpenOptions}>
            {showHint && (
              <span className="chip-placeholder">
                {formatMessage(messages.chooseAssignees)}...
              </span>
            )}
            {values.length > 0 &&
              values.map(
                (value, index) =>
                  all.includes(value.id) && (
                    <Chip
                      key={value.key}
                      label={value.name}
                      className="mj-chip-content"
                      onDelete={() => this.onDeleteChip(index)}
                    />
                  ),
              )}
            <ArrowDropDown
              className={cn('mj-chip-field-arrow-icon', {
                'arrow-icon-rotate': isOpen,
              })}
            />
          </Paper>
          <Collapse in={isOpen} timeout="auto" unmountOnExit>
            <MenuList className="mj-chip-option-list">
              {options.map(({ isLabel, key, title, id, name }, index) =>
                isLabel ? (
                  <Typography key={key} variant="subtitle1">
                    {title}
                  </Typography>
                ) : (
                  <MenuItem
                    key={key}
                    value={index}
                    selected={all.includes(id)}
                    onClick={this.onChangeOption}>
                    {name}
                  </MenuItem>
                ),
              )}
            </MenuList>
          </Collapse>
        </div>
      </Paper>
    )
  }
}

export default injectIntl(AssignAllChipList)
